export default __webpack_public_path__ + "static/07-d5b547ac76afafe957aafd411099e271.png";